import React, { useState, useEffect } from 'react'

import { LocalPersistence } from '../../../factories';
import { Typography, message } from 'antd';
import SearchTablePublic from '../../CSIComponents/SearchTable/SearchTable'
import TableDetailEdit from './TableDetail/TableDetailEdit'
import TableDetailAdd from './TableDetail/TableDetailAdd'
import TableDetailView from './TableDetail/TableDetailView'
import { getRatePlans } from '../../../services/rateplan'
import PageContainer from '../../CSIComponents/PageContainer'
import { Tabs } from 'antd'
import Loading from '../../Loading';
import DataSourceTypes from './../../CSIComponents/SearchTable/SearchTableInterface';
import { sortHelper } from '../../../helpers/misc/sortHelper'

const { TabPane } = Tabs


const RatePlans = (props: any) => {
    const [currentLine, setCurrentLine] = useState<DataSourceTypes>({})
    const [currentFlag, setCurrentFlag] = useState<string>('table')
    const [dataSource, setDataSource] = useState<DataSourceTypes[]>([])
    const [tableLoading, setTableLoading] = useState<boolean>(false)
    const zhhColumns = [
        {
            title: '',
            key: 'index',
            // @ts-expect-error
            render: (text: string, record: [], index: number) => Number(record?.key) ? Number(record?.key) + 1 : index += 1,
            width: '40px'
        },
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            ellipsis: 'true',
            sorter: (a: [], b: []) => sortHelper(a, b, 'code'),
            showSorterTooltip: false
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            ellipsis: 'true',
            sorter: (a: [], b: []) => sortHelper(a, b, 'name'),
            showSorterTooltip: false
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            ellipsis: 'true',
            sorter: (a: [], b: []) => sortHelper(a, b, 'description'),
            showSorterTooltip: false
        }/* ,
        {
            title: 'Tags',
            dataIndex: 'tags',
            key: 'tags',
            render: (text: any) => {
                return (<div style={{ width: '90%', display: 'flex', alignItems: 'center' }}>
                    <Typography.Paragraph
                        style={{ marginTop: 12 }}
                        ellipsis={{
                            rows: 1
                        }}
                    >
                        {text?.split(' | ').map((item: any, index: any) => {
                            if (item) {
                                return <span style={{
                                    display: 'inline-block',
                                    border: '1px solid #ccc',
                                    borderRadius: '10px',
                                    padding: '0 5px',
                                    boxSizing: 'border-box',
                                    marginRight: 8,
                                }}>
                                    {item}</span>
                            }
                            return '';
                        })}
                    </Typography.Paragraph>


                    {text && <div style={{ border: "1px solid #ccc", borderRadius: "50%", padding: '0 4px', height: '20px' }}>{text && text.split(' | ').length}</div>}
                </div>)
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'tags'),
            showSorterTooltip: false
        }, */
    ]
    const getData = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        setTableLoading(true)
        getRatePlans(session.supplier, session.propertyId).then(res => {
            setTableLoading(false)
            if (res.result.success) {
                const resData = res && res.property && res.property.rateplans && res.property.rateplans.length != 0 ? res.property.rateplans : []
                resData.forEach((item: any, index: number) => { item.key = '' + index; })
                setDataSource(resData);
            } else {
                message.error({
                    content: res?.error[0]?.message || 'operation failed'
                });
            }
        }, err => {
            message.error({
                content: err.message || err.error[0].message
            });
            setTableLoading(false)
        });
    }
    useEffect(() => {
        getData()
        currentFlag === 'edit' || currentFlag === 'add' ? props.isEditable(true) : props.cancelEditable(false)
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [currentFlag])

    // table
    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Rate Plans" key="1" disabled={currentFlag === 'edit' || currentFlag === 'add'}>

                {currentFlag === 'edit' && <TableDetailEdit setCurrentLine={setCurrentLine} setCurrentFlag={setCurrentFlag} currentLine={currentLine} />}
                {currentFlag === 'add' && <TableDetailAdd setCurrentFlag={setCurrentFlag} />}
                {currentFlag === 'view' && <TableDetailView setCurrentFlag={setCurrentFlag} currentLine={currentLine} />}

                {currentFlag === 'table' && !tableLoading && <div style={{ marginTop: -15, }}>
                    <PageContainer >
                      <SearchTablePublic
                        columns={zhhColumns}
                        dataSourceProps={dataSource}
                        setCurrentLine={setCurrentLine}
                        setAddFlag={setCurrentFlag}
                        addButton={true}
                        pagination='rate_plans'
                    />
                    </PageContainer>
                </div>}
                {tableLoading && <Loading type={'large'} />}
            </TabPane>
        </Tabs>
    )
}

export default RatePlans
